export default {
	updateEmailReceiveAlert(state, res) {
		state.EmailReceiveAlert = res;
	},
	updateEmailReceiveAlerts(state, res) {
		state.EmailReceiveAlerts = res;
	},
	addEmailReceiveAlert(state, res) {
		state.EmailReceiveAlerts.push({ IsAction: true });
	}
};
